/** German-canonical copy of the HLRE import report (IMM-1435.2). Lead-Ops reads it; register: informal `du` where addressed. */
export const hlreImport = {
  header:
    'Import: {account} · Lauf: {runId} · Modus: {mode, select, DRY_RUN {Probelauf} IMPORT {Import} FOLLOW_UP {Nachlauf} other {}} · Gestartet von: {startedBy}',
  sections: {
    package: 'Paket',
    setUp: 'Einrichtung',
    cases: 'Vorgänge',
    decisionRows: 'Mengen je Entscheidungszeile',
    drift: 'Abweichungen',
    sideEffects: 'Nebenwirkungen',
    notes: 'Hinweise',
  },
  package: {
    format: 'Format: {format}',
    runAt: 'Laufdatum: {runAt}',
    preparedAt: 'Vorbereitet am: {preparedAt}',
    checksums: 'Prüfsummen',
  },
  cases: {
    counts: 'Angelegt: {created} · Übersprungen: {skipped} · Fehlgeschlagen: {failed}',
    failed: 'Fehlgeschlagen',
    skipped: 'Übersprungen',
    created: 'Angelegt',
    unknownKeys: 'Unbekannte Schlüssel',
  },
  decisionRows: {
    row: 'Zeile',
    package: 'Paket',
    created: 'Angelegt',
    skipped: 'Übersprungen',
    failed: 'Fehlgeschlagen',
  },
  sideEffects: 'E-Mails: {emails} · Sprachmodell-Aufrufe: {languageModelCalls} · Kalendereinträge: {calendarEntries}',
  setUpFailed: 'Einrichtung fehlgeschlagen bei {element}: {reason}. Es wurde kein Vorgang importiert.',
  phoneOmitted:
    'Firmentelefon nicht übernommen: „{raw}“ ist keine gültige internationale Nummer. Bei Bedarf im Workspace nachtragen.',
  postalCodesSkipped: 'Standort-PLZ: keine im Paket, Zuordnung übersprungen.',
  setUp: {
    item: '{element}: {outcome, select, CREATED {angelegt} EXISTING {vorhanden} other {}}',
    elements: {
      COMPANY_ADDRESS: 'Firmenadresse',
      WORKSPACE: 'Workspace',
      COMPANY: 'Firma',
      MAIN_ORGANIZATION: 'Hauptstandort',
      POSTAL_CODES: 'PLZ',
      MEMBER: 'Mitglied {subject}',
      LEAD_RECIPIENT: 'Lead-Empfänger',
      LEAD_PARTNER: 'Lead-Partner HLRE',
      PARTNER_PROFILE: 'Partnerprofil',
      CONTACT_MAPPING: 'Contact-Zuordnung {subject}',
      HLRE_LINK: 'HLRE-Verknüpfung',
    },
  },
  caseFailed: '{key}: nicht importiert – {reason}. Nach der Korrektur mit diesem Schlüssel erneut importieren.',
  caseDrift: '{key}: bereits importiert, im Paket geändert ({parts}). Nichts geändert – bitte manuell klären.',
  caseReusedDrift:
    '{key}: {parts} aus einem früheren Vorgang übernommen, im Paket abweichend. Nichts geändert – bitte manuell klären.',
  parts: {
    lead: 'Lead',
    statusHistory: 'Status',
    conversion: 'Konvertierung',
    deal: 'Deal',
    milestones: 'Meilensteine',
    conditions: 'Konditionen',
    hlreState: 'HLRE-Zustand',
    activities: 'Aktivitäten',
    nextAction: 'nächste Aktion',
    propertyState: 'Objektstatus',
    owner: 'Eigentümer',
    property: 'Objekt',
  },
  passedPlannedAppointment: 'Vor-Ort-Termin geplant am {date} (laut Salesforce nicht als stattgefunden markiert)',
  passedPlannedCall: 'Telefontermin geplant am {date} (laut Salesforce nicht als stattgefunden markiert)',
  none: 'Keine.',
  reportWritten: 'Bericht: {path}',
} as const;
